var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"href":this.location,"color":_vm.color,"rounded":"","target":"_blank","fixed":"","top":"","right":""}},[_vm._v(" "+_vm._s(this.text)+" "),_c('v-icon',{attrs:{"right":"","large":""}},[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }